import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { toLower } from 'lodash';
export var templateParser = function templateParser(str, vars) {
  return str.replace(/{{(\w+)}}/g, function (_, match) {
    return vars[match];
  });
};

/**
 * Функция, которая дает возможность из паттерна делать строку в перемешку с Реакт компонентами
 */

export function templateParserJSX(value, vars) {
  if (!value) return [''];
  if (!vars) return [value];
  return value.split(/({{\w+}})/gi) // Оставляет в массиве сплитеры
  .filter(Boolean).map(function (entry) {
    var match = entry.match(/{{(\w+)}}/i);
    if (!match) return entry;
    var _match = _slicedToArray(match, 2),
      captureMatch = _match[1];
    return vars[captureMatch];
  });
}
export var isLowerCaseEquals = function isLowerCaseEquals(str1, str2) {
  return toLower(str1) === toLower(str2);
};